import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { wizardParentState } from '../RouteConfig';
import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import './BuildingCoverages.scss';

var fn = function fn($scope, $state, $rootElement, StateUtils, $q, ModalService, $stateParams, CPCoverablesService, CoveragesUtil) {
    $scope.flowModel = $state.get(wizardParentState).data.flow;

    var ctrl = Object.create(BaseCtrl);

    var model = StateUtils.activeDataForState(true).model;
    $scope.jobID = model.quoteID ? model.quoteID.value : model.jobID.value;
    $scope.sessionID = SessionUtil.getSessionUUID(model);

    ctrl.init = function () {
        $rootElement.scrollTop(0);

        $scope.dependentCoverages = CoveragesUtil.getDependentCoverages();
        var sequencer = CoveragesUtil.getSequencer();
        $scope.location = $stateParams.model.selectedLocation;
        $scope.building = $stateParams.model.selectedBuilding;

        $scope.onCovChange = function (updatedCoverage) {
            return updateBuildingCoverages(updatedCoverage);
        };

        $scope.editLocation = function () {
            $scope.flowModel.jumpToStep('SelectLocation');
        };

        $scope.editBuilding = function () {
            $scope.flowModel.jumpToStep('BuildingInfo');
        };

        $scope.next = function (doNext) {
            if (CoveragesUtil.validateForm($scope.form.newBuildingCoverages)) {
                $scope.onCovChange().then(function () {
                    return doNext($stateParams.model);
                }, function () {
                    doNext();
                }).catch(function () {
                    ModalService.showError('quoteandbind.common.flow.error.Error', 'quoteandbind.common.flow.error.An error has occurred...');
                });
            } else {
                doNext();
            }
        };

        var updateBuildingCoverages = function updateBuildingCoverages(updatedCoverage) {
            $scope.coveragesLoading = true;
            $scope.updateBuildingCoverages = sequencer(CPCoverablesService.updateCPBuildingCoverages($scope.jobID, $scope.location.publicID, $scope.building, SessionUtil.getSessionUUID(model)));

            $scope.updateBuildingCoverages.then(function (result) {
                CoveragesUtil.updateCoverages(updatedCoverage, result.coverages, $scope.building.coverages);
            }).catch(function () {
                // CPUI: the message to be displayed on this modal needs to be reviewed. Sanja will have input on it.
                ModalService.showError('quoteandbind.cp.directives.cp-building-directive.Building not saved', 'quoteandbind.cp.Please check for errors and try again');
            }).then(function () {
                executeValidations();
            }).finally(function () {
                $scope.coveragesLoading = false;
            });

            return $scope.updateBuildingCoverages;
        };

        var executeValidations = function executeValidations() {
            $scope.errorMessage = undefined;
            if ($scope.building.coverages.every(function (c) {
                return !c.selected;
            })) {
                $scope.errorMessage = 'quoteandbind.cp.Please select at least one coverage to proceed.';
            }
        };
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$rootElement', 'StateUtils', '$q', 'ModalService', '$stateParams', 'qnb.cpCoverablesService', 'CoveragesUtil'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/AddBuildingWizard/buildingCoverages/BuildingCoveragesCtrl.js
// module id = 981
// module chunks = 0